import { Heading } from "@chakra-ui/react";
import Billing from "components/Core/AccountInfo/Billing";
import { getLayout } from "components/Layout/BrandSettings";
import HeadTitle from "components/Shared/HeadTitle";

export const TITLE = "Subscription & Billing";

export default function BrandBillingIndex() {
  return (
    <>
      <HeadTitle title={TITLE} />
      <Heading as="h1" variant="section-header">
        {TITLE}
      </Heading>

      <Billing />
    </>
  );
}

BrandBillingIndex.getLayout = getLayout;
